/*
Copyright (c) 2026 Jim Thatcher

This software is the property of Jim Thatcher, and may not be used without permission.
*/
/* global SCHEDULE */

window.SCHEDULE = (function(my) {
  my.cid = 0;
  my.tid = 0;
  my.query = {};
  my.getSchedule = my.getSchedule || function() {};
  return my;
} (window.SCHEDULE || {}));

function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
};

async function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    // If the query string does not contain cid and tid, check the org and team cookies
    if (!query['cid'] && !query['tid']) {
        var org = getCookie("org");
        var team = getCookie("team");
        if (org && team) {
            query['cid'] = org;
            query['tid'] = team;
          } else {
            // parse the org and team slugs from the path (after the /public/pagename/ part) and look up the ids from /rest/lookupteam
            var path = window.location.pathname;
            var pathParts = path.split('/');
            var orgSlug = pathParts[pathParts.length - 2];
            var teamSlug = pathParts[pathParts.length - 1];
            console.debug("Looking up team: " + orgSlug + '/' + teamSlug);
            await fetch('/rest/lookupteam/' + orgSlug + '/' + teamSlug)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                query['cid'] = data['cid'];
                query['tid'] = data['tid'];
                console.debug("Found team: " + query['cid'] + '/' + query['tid']);
            })
            .catch(function(err) {
                console.error("Error looking up team: " + err);
            });
        }
    }
    console.debug("Query: " + JSON.stringify(query));
    return query;
};

SCHEDULE.getSchedule = async function () {
    // Read the schedule from database
    console.debug("Getting schedule for " + SCHEDULE.cid + '/' + SCHEDULE.tid);
    fetch('/rest/db/gamelist?cid=' + SCHEDULE.cid + '&tid=' + SCHEDULE.tid + '&all=true&season=' + new Date().getFullYear())
    .then(function (response) {
        if (response.status === 401) {
            console.log("Unauthorized");
        } else {
            return response.json();
        }
    })
    .then(function (data) {
        var element = document.getElementById("schedule-list");
        var hideLocation = SCHEDULE.query['nolocation'] != null || false;
        // Adjust grid-template-columns based on the presence of nolocation parameter
        if (hideLocation) {
            console.debug("Hiding location column");
            element.style.gridTemplateColumns = "auto 42px auto"; // Remove the fourth column
        } else {
            element.style.gridTemplateColumns = "auto 42px auto auto"; // Default columns
        }
        for (var i = 0; i < data.length; i++) {
            (function (game) {
                var gameColor = game.home ? game.guestColor : game.homeColor;
                var opponentLogo = game.home ? game.guestIcon : game.homeIcon;
                var logoPath = '/rest/image/team/' + opponentLogo + '?uuid=' + game.uuid;
                var gameDateCell = document.createElement("div");
                gameDateCell.className = "grid-cell";
                var gameDate = new Date(game.gameDate + 'Z');
                // Create a div for the date
                var dateDiv = document.createElement("div");
                dateDiv.textContent = gameDate.toLocaleString(undefined, {
                    month: 'numeric',
                    day: 'numeric',
                });
                
                // Create a div for the time
                var timeDiv = document.createElement("div");
                timeDiv.textContent = gameDate.toLocaleString(undefined, {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                });
                timeDiv.textContent = timeDiv.textContent.replace(" PM", ""); // Remove the space between the time and AM/PM
                
                // Apply flexbox styling to stack dateDiv and timeDiv vertically
                gameDateCell.style.display = "flex";
                gameDateCell.style.flexDirection = "column";
                gameDateCell.style.alignItems = "center"; // Center align the text
                // Append both divs to the gameDateCell
                gameDateCell.appendChild(dateDiv);
                gameDateCell.appendChild(timeDiv);
                gameDateCell.style.justifyContent = "center"; // Center the text in the cell
                gameDateCell.style.backgroundColor = gameColor; // Set background color based on game type

                var logoCell = document.createElement("div");
                logoCell.className = "grid-cell";
                // atCell.textContent = game.home ? 'vs' : '@';
                logoCell.style.backgroundColor = gameColor; // Set background color based on game type
                var logoImg = document.createElement("img");
                logoImg.src = logoPath;
                logoImg.alt = "Team Logo";
                logoImg.style.width = "40px";
                logoImg.style.height = "40px";
                logoCell.appendChild(logoImg); // Append the logo image to the logo cell

                var opponentNameCell = document.createElement("div");
                opponentNameCell.className = "grid-cell";
                opponentNameCell.textContent = (game.home ? (' vs ' + game.guestName) : (' @ ' + game.homeName));
                opponentNameCell.style.backgroundColor = gameColor; // Set background color based on game type
                if (game.url.length > 12) {
                    opponentNameCell.innerHTML = `<a href="${game.url}" target="_blank" class="location-link">${opponentNameCell.textContent}</a>`;
                }
                opponentNameCell.style.alignContent = "center"; // Center the text in the cell
                // horizontally center the text in the cell
                opponentNameCell.style.display = "flex";
                opponentNameCell.style.justifyContent = "center";
                // Create a container for the row
                var rowContainer = document.createElement("div");
                rowContainer.className = "grid-row"; // Add a class for styling
                rowContainer.style.backgroundColor = gameColor; // Set background color based on game type
                // Append cells to the row container
                rowContainer.appendChild(gameDateCell);
                rowContainer.appendChild(logoCell);
                rowContainer.appendChild(opponentNameCell);

                if (!hideLocation) {
                    var locationCell = document.createElement("div");
                    locationCell.className = "grid-cell";
                    // Check if game.location ends with a URL in parentheses
                    var locationText = game.location;
                    var urlMatch = locationText.match(/\((https?:\/\/[^\s]+)\)$/);

                    if (urlMatch) {
                        // Extract the URL and the text before it
                        var url = urlMatch[1];
                        var textBeforeUrl = locationText.slice(0, urlMatch.index) + '&nbsp;';

                        // Create a clickable link
                        locationCell.innerHTML = `${textBeforeUrl}<a href="${url}" target="_blank" class="location-link">Tickets</a>`;
                    } else {
                        locationCell.textContent = locationText;
                    }

                    locationCell.style.background = gameColor;
                    locationCell.style.justifyContent = "center"; // Center the text in the cell
                    rowContainer.appendChild(locationCell);
                }
                // Append the row container to the schedule list
                element.appendChild(rowContainer);
                // Add click event listener to the row to open the game page in a new window
                logoCell.addEventListener("click", function() {
                    window.open(game.url, '_blank');
                });
            })(data[i]);
        }
    })
    .catch(function (err) {
        console.log('error: ' + err);
    })
};

async function initializeSchedule() {
  SCHEDULE.query = await parseQuery(window.location.search);
  SCHEDULE.cid = (SCHEDULE.query['cid']) ? SCHEDULE.query.cid : 0;
  SCHEDULE.tid = (SCHEDULE.query['tid']) ? SCHEDULE.query.tid : 0;
  console.debug("Schedule: " + SCHEDULE.cid + '/' + SCHEDULE.tid);

  if (!!SCHEDULE.cid && !!SCHEDULE.tid) {
    SCHEDULE.getSchedule();
  }
}
initializeSchedule();
